export const SUPPORTED_LANGUAGES = [
  'en',
  'hi',
  'ta',
  'te',
  'mr',
  'gu',
  'bn',
  'kn',
  'ml',
  'pa',
  'or',
  'as',
  'ur',
] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export const LANGUAGE_OPTIONS: Array<{
  code: SupportedLanguage;
  label: string;
  shortLabel: string;
  preferenceName: string;
}> = [
  { code: 'en', label: 'English', shortLabel: 'EN', preferenceName: 'English' },
  { code: 'hi', label: 'हिन्दी', shortLabel: 'हिं', preferenceName: 'Hindi' },
  { code: 'ta', label: 'தமிழ்', shortLabel: 'TA', preferenceName: 'Tamil' },
  { code: 'te', label: 'తెలుగు', shortLabel: 'TE', preferenceName: 'Telugu' },
  { code: 'mr', label: 'मराठी', shortLabel: 'MR', preferenceName: 'Marathi' },
  { code: 'gu', label: 'ગુજરાતી', shortLabel: 'GU', preferenceName: 'Gujarati' },
  { code: 'bn', label: 'বাংলা', shortLabel: 'BN', preferenceName: 'Bengali' },
  { code: 'kn', label: 'ಕನ್ನಡ', shortLabel: 'KN', preferenceName: 'Kannada' },
  { code: 'ml', label: 'മലയാളം', shortLabel: 'ML', preferenceName: 'Malayalam' },
  { code: 'pa', label: 'ਪੰਜਾਬੀ', shortLabel: 'PA', preferenceName: 'Punjabi' },
  { code: 'or', label: 'ଓଡ଼ିଆ', shortLabel: 'OR', preferenceName: 'Odia' },
  { code: 'as', label: 'অসমীয়া', shortLabel: 'AS', preferenceName: 'Assamese' },
  { code: 'ur', label: 'اردو', shortLabel: 'UR', preferenceName: 'Urdu' },
];

const LANGUAGE_ALIAS: Record<string, SupportedLanguage> = {
  english: 'en',
  hinglish: 'en',
  hindi: 'hi',
  tamil: 'ta',
  telugu: 'te',
  marathi: 'mr',
  gujarati: 'gu',
  bengali: 'bn',
  bangla: 'bn',
  kannada: 'kn',
  malayalam: 'ml',
  punjabi: 'pa',
  odia: 'or',
  oriya: 'or',
  assamese: 'as',
  urdu: 'ur',
};

export const normalizeLanguage = (value?: string | null): SupportedLanguage => {
  const normalized = value?.toLowerCase().trim();
  if (!normalized) return 'en';

  const baseLanguage = normalized.split(/[-_]/)[0];
  const supported = SUPPORTED_LANGUAGES.find((language) => language === baseLanguage);
  if (supported) return supported;

  return LANGUAGE_ALIAS[normalized] || 'en';
};

export const getLanguagePreferenceName = (language: string) => {
  const normalized = normalizeLanguage(language);
  return LANGUAGE_OPTIONS.find((option) => option.code === normalized)?.preferenceName || 'English';
};

export const getLanguageFromPreferenceName = (language?: string | null) => normalizeLanguage(language);
